import { Button, Text } from '@cloudflare/kumo'
import { CheckCircleIcon, HourglassMediumIcon } from '@phosphor-icons/react'
import { useTranslation } from '../../i18n'
import './enroll.css'

interface EnrollDoneProps {
  status: 'approved' | 'pending-approval'
  /** Label + handler for the next-step action (sign in / go home). */
  actionLabel: string
  onAction: () => void
  testId?: string
}

/** Terminal state of both wizards: status icon, title/message, next action. */
export function EnrollDone({ status, actionLabel, onAction, testId }: EnrollDoneProps) {
  const { t } = useTranslation()
  const approved = status === 'approved'
  return (
    <div data-testid={testId} className="flex flex-col items-center gap-4 py-4 text-center">
      {approved ? (
        <CheckCircleIcon size={56} weight="fill" className="text-kumo-success" />
      ) : (
        <HourglassMediumIcon size={56} className="text-kumo-warning" />
      )}
      <div className="flex flex-col gap-2">
        <Text variant="heading3" as="h2">
          {approved ? t('enroll.terminal.approvedTitle') : t('enroll.terminal.pendingTitle')}
        </Text>
        <Text variant="secondary">
          {approved ? t('enroll.terminal.approvedMessage') : t('enroll.terminal.pendingMessage')}
        </Text>
      </div>
      <Button variant="primary" onClick={onAction} className="enroll-cta w-full">
        {actionLabel}
      </Button>
    </div>
  )
}
